<div [hidden]="!loading" class="spinner-host" [style.background-color]="bgColor"  #loader>
    <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</div>
<!-- [ngClass]="{ 'loading': loading }" -->

<div class="image" [style.backgroundImage] ="'url(' + imageUrl +')'">
<img [hidden]="loading"
     alt="{{alternativeText}}" 
     src="/assets/images/overlay.png" 
     (load)="loaded($event)" 
     (error)="placeholder($event)" />
</div>